module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gift-wechat-box",
    class: {
      'ani': _vm.showWechatGiftAni
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "head"
  }), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("付款后24小时，若好友未领取将自动退款。")]), _vm._v(" "), _c('div', {
    staticClass: "btn-gift",
    on: {
      "click": _vm.doWechatGift
    }
  }, [_vm._v("立即送礼")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit"
  }, [_c('img', {
    attrs: {
      "src": "//img.thebeastshop.com/app/4.0/icon/gift/txt-title.png?t=2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "para"
  }, [_c('p', [_c('i', [_vm._v("1")]), _vm._v("为好友挑选礼物")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("2")]), _vm._v("定制祝福并付款("), _c('span', {
    staticStyle: {
      "color": "#87522E",
      "font-weight": "600"
    }
  }, [_vm._v("无需地址")]), _vm._v(")")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("3")]), _vm._v("赠送微信好友")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("4")]), _vm._v("好友收下你的心意")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("5")]), _vm._v("野兽派将礼物送至你的好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b8bdee1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/gift/gift-box.vue
// module id = 1067
// module chunks = 2